"use client";

import { ReactNode } from "react";
import { Dialog as MuiDialog } from "@mui/material";
import { useEditDialog } from "../Providers/EditDialogContext";

interface DialogProps {
  children: ReactNode;
}

export default function Dialog({ children }: DialogProps) {
  const { editDialogOpen, closeEditDialog } = useEditDialog();

  return (
    <MuiDialog
      open={editDialogOpen}
      onClose={closeEditDialog}
      maxWidth="md"
      fullWidth
    >
      {children}
    </MuiDialog>
  );
}
